import dayjs from "dayjs";
import { getApiError, postFileUpload } from "tm-shared/api";
import { extractBase64Content } from "tm-shared/utils";

import { photoStorage } from "@/Services/PhotoStorage";
import { parseUploadedUrl } from "@/Services/UploadPhoto/utils";

export const uploadPhoto = async (photoId: string) => {
    const photo = await photoStorage.getPhoto(photoId);
    const photoInfo = await photoStorage.getPhotoInfo(photoId);

    if (!photo || !photoInfo) {
        throw new Error(`No data for photo with id ${photoId}`);
    }

    if (photoInfo.uploaded) return;

    const parseData = parseUploadedUrl(photoInfo.id);

    if (!parseData) return;

    const { pointId, middlePath, filename } = parseData;

    const normalized = extractBase64Content(photo);

    try {
        await postFileUpload({
            base64Content: normalized,
            filename,
            space: pointId,
            middlePath,
        });

        if (photoInfo.taskComplete) {
            await photoStorage.deletePhoto(photoId);
        } else {
            await photoStorage.updatePhotoInfo(photoId, {
                uploaded: true,
                lastError: undefined,
                lastUploadAt: dayjs().toISOString(),
            });
        }
    } catch (err) {
        console.error("Photo upload failed", err);
        const { displayMessage } = getApiError(err);

        await photoStorage.updatePhotoInfo(photoId, {
            uploadAttempts: photoInfo.uploadAttempts + 1,
            lastUploadAt: dayjs().toISOString(),
            lastError: displayMessage,
        });
    }
};
